/* tslint:disable */
/* eslint-disable */
/**
 * DUPR Backend APIs (Internal)
 * Internal RESTful APIs to access DUPR ratings, users and provide matches.
 *
 * The version of the OpenAPI document: v1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import type { BenefitClaimView } from './benefit-claim-view';
// May contain unused imports in some cases
// @ts-ignore
import type { ClaimPolicyView } from './claim-policy-view';
// May contain unused imports in some cases
// @ts-ignore
import type { ResolvedTerm } from './resolved-term';
// May contain unused imports in some cases
// @ts-ignore
import type { WorkflowProgress } from './workflow-progress';

/**
 * A benefit the member holds, with what it is worth and where it stands
 * @export
 * @interface HeldBenefitView
 */
export interface HeldBenefitView {
    /**
     * 
     * @type {number}
     * @memberof HeldBenefitView
     */
    'grantId': number;
    /**
     * 
     * @type {string}
     * @memberof HeldBenefitView
     */
    'bundleUrn': string;
    /**
     * 
     * @type {string}
     * @memberof HeldBenefitView
     */
    'state': HeldBenefitViewStateEnum;
    /**
     * 
     * @type {string}
     * @memberof HeldBenefitView
     */
    'expires': string;
    /**
     * What the member reads: the program\'s label
     * @type {string}
     * @memberof HeldBenefitView
     */
    'label'?: string;
    /**
     * What was promised, once claimed; empty while unclaimed
     * @type {Array<ResolvedTerm>}
     * @memberof HeldBenefitView
     */
    'terms': Array<ResolvedTerm>;
    /**
     * What was promised, once claimed; null while unclaimed. Show verbatim.
     * @type {string}
     * @memberof HeldBenefitView
     */
    'worth'?: string;
    /**
     * The claim\'s outstanding step, if any
     * @type {WorkflowProgress}
     * @memberof HeldBenefitView
     */
    'progress'?: WorkflowProgress;
    /**
     * Each kind of target this may be claimed at; several entries mean either/or
     * @type {Array<ClaimPolicyView>}
     * @memberof HeldBenefitView
     */
    'claimPolicies': Array<ClaimPolicyView>;
    /**
     * Null exactly when the benefit is unclaimed
     * @type {BenefitClaimView}
     * @memberof HeldBenefitView
     */
    'claim'?: BenefitClaimView;
}

export const HeldBenefitViewStateEnum = {
    Available: 'AVAILABLE',
    Assigned: 'ASSIGNED',
    PendingStep: 'PENDING_STEP',
    Redeemed: 'REDEEMED',
    Expired: 'EXPIRED'
} as const;

export type HeldBenefitViewStateEnum = typeof HeldBenefitViewStateEnum[keyof typeof HeldBenefitViewStateEnum];


